module.exports = __webpack_public_path__ + "7abe0cd0d686db5e0ccfb113126e4d6a.fbx";